import React from 'react';
import { useTranslation } from 'react-i18next';

import { LogInButton } from '../LogInButton';

import DgLogoIcon from '../../../../icons/DgLogo';
import PersonIcon from '../../../../icons/Person';
import DrawPencil from '../../../../icons/DrawPencil';
import TeacherBoard from '../../../../icons/TeacherBoard';
import ArrowLeft from '../../../../icons/ArrowLeft';

import './index.scss';

const { REACT_APP_FEIDE_CLIENT_ID: FEIDE_CLIENT_ID, REACT_APP_FEIDE_REDIRECT_URI: FEIDE_REDIRECT_URI } = process.env;

const url = `https://auth.dataporten.no/oauth/authorization?client_id=${FEIDE_CLIENT_ID}&response_type=code&redirect_uri=${FEIDE_REDIRECT_URI}&scope=openid`;
const adminUrl = 'https://admin.digitaluniverse.no';
const adminRedirect = 'https://www.home.digitaluniverse.no/creator';

export const LogInSecondStep = ({ setShowSecondScreen }) => {
  const { t } = useTranslation();

  return (
    <div className="login-wrapper">
      <div className="login-container">
        <div className="login-logo-container">
          <DgLogoIcon />
          <span>igital Universe</span>
        </div>

        <div className="login-container-text">
          <h1>{t('Welcome to Digital Universe')}</h1>
          <h2>{t('The place where learning stories come alive')}</h2>
        </div>

        <div className="login-btn-container">
          <p className="login-btn-container-title">{t('Continue as')}</p>
          <LogInButton title={t('User')} subtitle={t('Play, discover and learn')} icon={<PersonIcon />} url={url} />
          <LogInButton
            title={t('Сreator')}
            subtitle={t('Discover learning stories for your students')}
            icon={<DrawPencil />}
            url={url}
          />
          <LogInButton
            title={t('Trainer')}
            icon={<TeacherBoard />}
            subtitle={t('Create interactive and compelling stories for your audience')}
            url={adminUrl}
          />
          <a className="no-account-text" href={adminRedirect}>
            {t('Have no account yet?')}
          </a>

          <ArrowLeft className="login-back-btn" onClick={() => setShowSecondScreen(false)} />
        </div>
      </div>
    </div>
  );
};
